import React, {Component} from "react";

import {View, Text, TextInput}  from 'react-native';

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'

import * as numeros from '../util/numeros'

import * as data from '../util/data'

import Botao from '../componentes/Botao'

import RotuloErro from '../componentes/RotuloErro'

import {ITEM_PROPOSTA_TIPO_PRODUTO, PEDIDO_SITUACAO_CANCELADO,
	PEDIDO_SITUACAO_ATIVO, ITEM_PROPOSTA_ORIGEM_PROPOSTA, width} from '../util/constantes'

import * as util from '../util/util'

import CampoNumero from '../componentes/CampoNumero'

import Bloco from '../componentes/Bloco'

import Imagem from '../componentes/Imagem'



export default class FormularioProposta extends Component {

	
	
	constructor(props) {
        
        super(props);
		
		this.state = {
			idProposta: null,
			apenas_ver: false,
			solicitante: null,
			titulo: null,
			nome_proponente: null,
			situacao_pedido: null,
			descricao_pedido: null,
			descricao: null,
			data_expiracao: null,
			valorTotal: null,
			valor_frete: null,
			prazo_entrega: null,
			prazo_servico: null,
			forma_pagamento: null,
		
			itens: [],
			msgErro: null,
			editando: false,
			itemTipo: null,
			itemOrigem: null,
			itemNome: null,
			itemDescricao: null,
			itemQuantidade: null,
			itemValorUnitario: null,
			itemValorTotal: null,
			itemMarca: null,
			itemModelo: null,
			itemCor: null,
			itemTamanho: null,
			itemObs: null,
			imagem_pedido: null
        };
		
		this.btSalvarRef = React.createRef();
    }
	
	
	setDados(proposta, itens, apenas_ver=false){
		
		this.setState({idProposta: proposta.id});
		this.setState({apenas_ver: apenas_ver});
		this.setState({solicitante: proposta.solicitante});
        this.setState({titulo: proposta.titulo});
		this.setState({nome_proponente: proposta.titnome_proponenteulo});
		this.setState({situacao_pedido: proposta.situacao_pedido});
		this.setState({descricao_pedido: proposta.descricao_pedido});
		this.setState({descricao: proposta.descricao});
		this.setState({data_expiracao: proposta.data_expiracao});
		this.setState({imagem_pedido: proposta.imagem_pedido});

		this.setState({itens: itens});
		
		this.setState({valor_frete: proposta.valor_frete});
		this.setState({prazo_entrega: proposta.prazo_entrega});
		this.setState({prazo_servico: proposta.prazo_servico});
		this.setState({forma_pagamento: proposta.forma_pagamento});
	
		if(proposta.id==null || !apenas_ver){
			
			this.setState({valorTotal: 0});
			
			this.setState({editando: true});
		}
		else
			this.atualizaValorTotal(itens);			
    }
	

	getDados(){

		return {
			descricao: this.state.descricao,
			valor: this.state.valorTotal,
			valor_frete: this.state.valor_frete,
			prazo_entrega: this.state.prazo_entrega,
			prazo_servico: this.state.prazo_servico,
			forma_pagamento: this.state.forma_pagamento,
			itens: this.state.itens	
        };
    }
	
	
	validar(){
		
		this.btSalvarRef.current.setCarregando(true)
	
		const { salvar } = this.props;	
	
		if(texto.isBlanck(this.state.descricao)){

            this.salvarErro("Informe o descrição do pedido.");
            return;
        } 
		
		for (const item of this.state.itens) {
			
			if(texto.isBlanck(item.valor_unitario)){

				this.salvarErro("Informe o custo unitário de todos os itens do pedido.");
				return;
			} 
		}	

		this.atualizaValorTotal(this.state.itens);
		
		salvar({"descricao": this.state.descricao, 
					"valor": numeros.truncar(this.state.valorTotal), 
						"valor_frete": this.state.valor_frete, 
							"prazo_entrega": this.state.prazo_entrega, 
								"prazo_servico": this.state.prazo_servico, 
									"forma_pagamento": this.state.forma_pagamento, 
										"itens": this.state.itens});
	}
	
	
	salvarErro(mensagem){
		
        this.btSalvarRef.current.setCarregando(false);
		this.setState({msgErro: mensagem});
    }


	salvarSucesso(){
		
		this.btSalvarRef.current.setCarregando(false)
		this.setState({msgErro: null});
	}


	novoItem(){
		
		this.setState({itemTipo: ITEM_PROPOSTA_TIPO_PRODUTO})
		this.setState({itemOrigem: ITEM_PROPOSTA_ORIGEM_PROPOSTA})
		this.setState({itemNome: null})
		this.setState({itemDescricao: null})
		this.setState({itemQuantidade: "1"})
		this.setState({itemValorUnitario: null})
		this.setState({itemValorTotal: null})
		this.setState({itemMarca: null})
		this.setState({itemModelo: null})
		this.setState({itemCor: null})
		this.setState({itemTamanho: null})
		this.setState({itemObs: null})
	}
   
	
	excluirItem(index){
	
		this.setState((prevState) => {
    		return { itens: prevState.itens.filter((_, i) => i !== index)};
		});
	}
   
   
	itemListaSomenteVer(item, index){

		const outras_infos =  util.outrasInfosItem(item);

		return (
			<View key={index} style={[estilos.bloco, estilos.sombra, {marginTop: 5, marginBottom: 5}]}> 
				<View style={{marginTop:10}}/>  
				<View style={{alignItems:'flex-end'}}> 
					<Text style={estilos.rotulo_titulo}>{item.tipo==ITEM_PROPOSTA_TIPO_PRODUTO?"Produto":"Serviço"}</Text>
				</View>
				<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
				<Text style={estilos.rotulo_padrao}>{item.descricao}</Text>
				{util.temConteudo(outras_infos) && <Text style={estilos.rotulo_padrao}>{outras_infos}</Text>}
				<View style={{marginTop:10}}/> 
				<View style={estilos.separador_cinza_claro}/> 
				<View style={{marginTop:5}}/> 
				<View style={estilos.grade}> 
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Text style={estilos.rotulo_titulo}>Valor (R$): {numeros.formataNumeroParaMostrar(item.valor_unitario)}</Text>
					</View>	
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
						<Text style={estilos.rotulo_titulo}>QTDe: {item.quantidade}</Text>
					</View>
				</View>	
				<View style={{marginTop:5}}/>
			</View>)
	}
	

	atualizaValorUnitario(valor, index){
		
		const newDados = [...this.state.itens];
		newDados[index].valor_unitario = valor;
		this.setState({itens: newDados})
		
		this.atualizaValorTotal(newDados);
	}
	
	
	atualizaValorTotal(itens){
		
		let total = 0;
		
		if(util.temConteudo(itens)){
			for(var item of itens)
				total += (item.quantidade*item.valor_unitario)
		}
		
		console.log("total "+total)
		this.setState({valorTotal: total})
	}
	
	
	atualizaObservacao(valor, index){
		
		const newDados = [...this.state.itens];
		newDados[index].observacao = valor;
		this.setState({itens: newDados})
	}
	
	
	itemListaEditar(item, index){
		
		const outras_infos =  util.outrasInfosItem(item);

		return (
			<Bloco key={index}> 
				<View style={{marginTop:10}}/>  
				<View style={{alignItems:'flex-end'}}> 
					<Text style={estilos.rotulo_padrao}>{item.tipo==ITEM_PROPOSTA_TIPO_PRODUTO?"Produto":"Serviço"}</Text>
				</View>
				<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
				<Text style={estilos.rotulo_padrao}>{item.descricao}</Text>
				{util.temConteudo(outras_infos) && <Text style={estilos.rotulo_padrao}>{outras_infos}</Text>}
				<Text style={estilos.rotulo_padrao}>QTDe {item.quantidade}</Text>
				{util.temConteudo(item.observacao_pedido) && <Text style={estilos.rotulo_padrao}>Obs: {item.observacao_pedido}</Text>}

				<View style={{marginTop:10}}/>
				
				<Text style={estilos.rotulo_padrao}>Valor Unitário (R$):</Text>
				
				<CampoNumero
					valor={item.valor_unitario}
					prefixo="R$: "
					setValor={(valor)=>this.atualizaValorUnitario(valor, index)}/>
				
				<View style={{marginTop:10}}/>
				
				<Text style={estilos.rotulo_padrao}>Observação (opcional):</Text>
				
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.atualizaObservacao(text, index)}
					maxLength={250}
					value={item.bbservacao}/>
				
			</Bloco>)
	}
	
	
	formularioEditarItem(){
		
		return (
			<View style={{ flex: 1}}>   
				<Bloco> 
					<View style={{marginTop:10}}/>  
					
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Detalhe da Proposta</Text>
					</View>

					<View style={{marginTop:10}}/>   
										
					<Text style={estilos.rotulo_titulo}>Descrição:</Text>

					<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={true}
							numberOfLines = {4}
							onChangeText={(text)=>this.setState({descricao: text})}
							maxLength={250}
							value={this.state.descricao}/>
					
					<View style={{marginTop:10}}/> 
					
					<Text style={estilos.rotulo_titulo}>Prazo de Entrega (em dias):</Text>
					
					<CampoNumero
						valor={this.state.prazo_entrega}
						prefixo=""
						casasDecimais={0}
						setValor={(valor)=>this.setState({prazo_entrega: valor})}/>
						
					<View style={{marginTop:10}}/> 
					
					<Text style={estilos.rotulo_titulo}>Valor Frete (R$):</Text>
					
					<CampoNumero
						valor={this.state.valor_frete}
						prefixo="R$: "
						setValor={(valor)=>this.setState({valor_frete: valor})}/>	
						
					<View style={{marginTop:10}}/> 
					
					<Text style={estilos.rotulo_titulo}>Prazo Execução de Serviço (em dias):</Text>
					
					<CampoNumero
						valor={this.state.prazo_servico}
						prefixo=""
						casasDecimais={0}
						setValor={(valor)=>this.setState({prazo_servico: valor})}/>
						
					
					<View style={{marginTop:10}}/> 
					
					<Text style={estilos.rotulo_titulo}>Formas de Pagamento:</Text>
					
					<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={false}
							onChangeText={(text)=>this.setState({forma_pagamento: text})}
							maxLength={250}
							value={this.state.forma_pagamento}/>
			
					<View style={{marginTop:10}}/> 
				
				</Bloco>
			

				{util.temConteudo(this.state.itens) && 
					this.state.itens.map((item, index) => this.itemListaEditar(item, index))	
				}
						
				<Bloco> 
					<View style={{marginTop:10}}/>   
					<Text style={estilos.rotulo_titulo}>Valor Total (R$): {numeros.formataNumeroParaMostrar(this.state.valorTotal)}</Text>
					<View style={{marginTop:10}}/>   
					
					<View style={{alignItems:'center'}}>
						<RotuloErro mensagem={this.state.msgErro}/>
					</View>
					
					{this.state.situacao_pedido == PEDIDO_SITUACAO_ATIVO && 

						<View style={{alignItems:'center'}}>
							<Botao 
								acao={()=>this.validar()}
								texto={!util.temConteudo(this.state.idProposta)?"Enviar Proposta":"Atualizar Proposta"}
								ref={this.btSalvarRef}/>   
							<View style={{marginTop:10}}/>   
						</View>	
					}
				</Bloco>
			</View>
		)
	}


    render() {
		
		return (
			<View style={{ flex: 1}}>   
				<Bloco> 
					
					<View style={{marginTop:10}}/>  
						
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Dados Gerais do Pedido</Text>	    
					</View>
							
					{this.state.imagem_pedido!=null && 
						<View style={{alignItems:'center'}}> 
							<View style={{marginTop:20}}/>   
							<Imagem imagem={this.state.imagem_pedido} tamanho={width- 60}/> 
						</View> 
					} 

					<Text style={estilos.rotulo_titulo}>Solicitante:</Text>
					
					<View style={{marginTop:10}}/>  				
					
					<Text style={estilos.rotulo_padrao}>{this.state.solicitante}</Text>

					<View style={{marginTop:10}}/>  

					<Text style={estilos.rotulo_titulo}>Título:</Text>
							
					<View style={{marginTop:10}}/>   	
							
					<Text style={estilos.rotulo_padrao}>{this.state.titulo}</Text>
									   
					<View style={{marginTop:10}}/>   
										
					<Text style={estilos.rotulo_titulo}>Descrição do Pedido:</Text>
						
					<View style={{marginTop:10}}/>   	
							
					<Text style={estilos.rotulo_padrao}>{this.state.descricao_pedido}</Text>
						
					{this.state.situacao_pedido != PEDIDO_SITUACAO_CANCELADO && 
						<View>
							<View style={{marginTop:10}}/> 
							<View style={estilos.grade}>
								<Text style={estilos.rotulo_titulo}>{this.state.situacao_pedido == PEDIDO_SITUACAO_ATIVO?'Expira':'Expirou'} em: </Text>
								<View style={estilos.coluna}> 	
									<Text style={estilos.rotulo_padrao}>{data.converteDataEuaParaBr(this.state.data_expiracao)}</Text>
								</View>
							</View>
						</View>
					}

					<View style={{marginTop:10}}/> 

					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Situação: </Text>
						<View style={estilos.coluna}> 	
							<Text style={estilos.rotulo_padrao}>{util.getDescricaoSituacaoPedido(this.state.situacao_pedido)}</Text>
						</View>
					</View>

					<View style={{marginTop:10}}/>   	

					{this.state.idProposta !=null && this.state.situacao_pedido != PEDIDO_SITUACAO_CANCELADO && 
					
						<View style={{alignItems:'center'}}>
							<View style={{marginTop:10}}/> 
							<Botao 
								acao={()=>this.props.abrirChat()}
								texto="Enviar Mensagem"/>   
						</View>
					}

					<View style={{marginTop:20}}/> 
				</Bloco>
			
				{this.state.editando && this.state.situacao_pedido == PEDIDO_SITUACAO_ATIVO?
					(this.formularioEditarItem()):
					(<View>
						<Bloco> 	
							<View style={{marginTop:10}}/>  
								
							<View style={{alignItems:'center'}}>
								<Text style={estilos.rotulo_titulo}>Proposta de Orçamento</Text>	    
							</View>

							<View style={{marginTop:20}}/> 

							<View style={estilos.grade}>
								<Text style={estilos.rotulo_titulo}>Proponente: </Text>
								<View style={estilos.coluna}> 	
									<Text style={estilos.rotulo_padrao}>{this.state.nome_proponente}</Text>
								</View>
							</View>

							<View style={{marginTop:10}}/>

							<Text style={estilos.rotulo_titulo}>Descrição da Proposta:</Text>
										
							<View style={{marginTop:10}}/>   	
										
							<Text style={estilos.rotulo_padrao}>{this.state.descricao}</Text>
								
							<View style={{marginTop:10}}/>   	
										
							<Text style={estilos.rotulo_titulo}>Prazo de Entrega (em dias):</Text>
										
							<View style={{marginTop:10}}/>   	
										
							<Text style={estilos.rotulo_padrao}>{this.state.prazo_entrega}</Text>
								
							<View style={{marginTop:10}}/>   	
								
							<Text style={estilos.rotulo_titulo}>Valor Frete (R$):</Text>
										
							<View style={{marginTop:10}}/>   	
										
							<Text style={estilos.rotulo_padrao}>{numeros.formataNumeroParaMostrar(this.state.valor_frete)}</Text>
								
							<View style={{marginTop:10}}/>   	
								
							<Text style={estilos.rotulo_titulo}>Prazo Execução de Serviço (em dias):</Text>
										
							<View style={{marginTop:10}}/>   	
										
							<Text style={estilos.rotulo_padrao}>{this.state.prazo_servico}</Text>
								
							<View style={{marginTop:10}}/>   	
								
							<Text style={estilos.rotulo_titulo}>Formas de Pagamento:</Text>
										
							<View style={{marginTop:10}}/>   	
										
							<Text style={estilos.rotulo_padrao}>{this.state.forma_pagamento}</Text>
								
							<View style={{marginTop:10}}/> 
							<View style={estilos.separador}/>
							<View style={{marginTop:10}}/> 	
													
							<Text style={estilos.rotulo_titulo}>Valor Total (R$): {numeros.formataNumeroParaMostrar(this.state.valorTotal)}</Text>
			
							<View style={{marginTop:10}}/> 
						</Bloco>

						{util.temConteudo(this.state.itens) && 
							this.state.itens.map((item, index) => this.itemListaSomenteVer(item, index))
						}
					</View>)
				}						
			</View>
		)	
	}
} 
